import {
    Directive,
    ElementRef,
    Input,
    OnChanges,
    OnDestroy,
    SimpleChanges,
} from '@angular/core';

declare var $: any;

@Directive({
    selector: '[nddFlot]',
})
export class NDDFlotDirective implements OnChanges, OnDestroy {

    /**
     * Dados do gráfico, no formato: [ [0, 10], [1, 20] ]
     */
    @Input() public flotDataset: any;
    /**
     * Ver em: https://github.com/flot/flot/blob/master/API.md#plot-options
     */
    @Input() public flotOptions: any;
    /**
     * Largura do gráfico
     */
    @Input() public flotWidth: any;
    /**
     * Altura do gráfico
     */
    @Input() public flotHeight: number;
    /**
     * Ver em: https://github.com/flot/flot/blob/master/API.md#customizing-the-data-series
     */
    @Input() public flotSeries: any;

    private element: any;
    private plot: any;

    constructor(public el: ElementRef) {
        this.element = $(this.el.nativeElement);

        this.plot = null;
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (!$.plot) {
            return;
        }
        if (changes.flotDataset) {
            this.onDatasetChanged(this.flotDataset);
        }
        if (changes.flotSeries) {
            this.onSerieToggled(this.flotSeries);
        }
    }

    public onDatasetChanged(dataset: any): any {
        if (this.plot) {
            this.plot.setData(dataset);
            this.plot.setupGrid();

            return this.plot.draw();
        }

        this.plot = this.init();
        this.onSerieToggled(this.flotSeries);

        return this.plot;
    }

    public onSerieToggled(series: any): void {

        if (!this.plot || !series) {
            return;
        }
        const someData: any = this.plot.getData();

        const toggleFor: any = (sName: any): any => {
            return (s: any, i: any): any => {
                if (someData[i] && someData[i][sName]) {
                    someData[i][sName].show = s;
                }
            };
        };

        for (const sName in series) {
            series[sName].forEach(toggleFor(sName));
        }

        this.plot.setData(someData);
        this.plot.draw();

    }

    public ngOnDestroy(): void {
        if (this.plot) {
            this.plot.shutdown();
        }
    }

    private init(): any {

        const heightDefault: number = 220;

        const width: any = this.flotWidth || '100%';
        this.flotHeight = this.flotHeight || heightDefault;

        this.element.css({
            width,
            height: this.flotHeight,
        });

        let plotObj: any;
        if (!this.flotDataset || !this.flotOptions) {
            return;
        }
        plotObj = $.plot(this.el.nativeElement, this.flotDataset, this.flotOptions);

        return plotObj;
    }
}
